import { create } from 'zustand';

type StatusFilter = 'all' | 'active' | 'inactive';
type SortKey = 'name-asc' | 'name-desc' | 'docs-desc' | 'fees-desc';

interface PermitTypesListStore {
  search: string;
  debounced: string;
  statusFilter: StatusFilter;
  sort: SortKey;
  page: number;
  createOpen: boolean;
  createError: string | null;
  setSearch: (q: string) => void;
  setDebounced: (q: string) => void;
  setStatusFilter: (f: StatusFilter) => void;
  setSort: (s: SortKey) => void;
  setPage: (p: number) => void;
  setCreateOpen: (open: boolean) => void;
  setCreateError: (e: string | null) => void;
}

export const usePermitTypesListStore = create<PermitTypesListStore>((set) => ({
  search: '',
  debounced: '',
  statusFilter: 'all',
  sort: 'name-asc',
  page: 1,
  createOpen: false,
  createError: null,
  setSearch: (q) => set({ search: q }),
  setDebounced: (q) => set({ debounced: q }),
  setStatusFilter: (f) => set({ statusFilter: f }),
  setSort: (s) => set({ sort: s }),
  setPage: (p) => set({ page: p }),
  setCreateOpen: (open) => set({ createOpen: open }),
  setCreateError: (e) => set({ createError: e }),
}));
